//const API_BASE_URL = "http://localhost:8080";
const API_BASE_URL = "https://balsuite.com"; 
export const COMPANY_NAME = "balvirt";
export default API_BASE_URL;
